import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["NextAuthProvider"] */ "/app/src/app/_providers/next-auth-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_providers/send-reading-progress-provider/send-reading-progress-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/_providers/system-notification-provider/system-notification-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
